import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { splitVoce, VoceLink, linkUsabile } from "@/components/NovitaVoce";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Check, Search } from "lucide-react";

const fmtD = (d) => { try { return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch { return d; } };
const fmtDT = (d) => new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const NotaCard = ({ n, onOpen, puo }) => (
  <article className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={`archivio-nota-${n.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div>
        <h2 className="font-heading text-lg text-slate-900">Versione {n.versione}</h2>
        <p className="text-sm text-slate-500">Aggiornamento n. {n.rev ?? "—"} del {fmtD(n.data)}{n.titolo ? ` · ${n.titolo}` : ""}</p>
      </div>
      {n.letta_il
        ? <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100" data-testid={`archivio-letta-${n.id}`}>Presa visione il {fmtDT(n.letta_il)}</Badge>
        : <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100" data-testid={`archivio-letta-${n.id}`}>Non ancora letta</Badge>}
    </div>
    <ul className="mt-3 space-y-2 text-sm text-slate-700">
      {n.voci.map((v, i) => {
        const { testo, link } = splitVoce(v);
        return (
          <li key={i} className="flex items-start gap-2"><Check className="h-4 w-4 mt-0.5 shrink-0 text-emerald-600" />
            <span className="flex-1">{testo}</span>
            {puo(link) && <VoceLink link={link} onOpen={onOpen} testid={`archivio-apri-${n.id}-${i}`} />}
          </li>
        );
      })}
    </ul>
  </article>
);

export default function ArchivioNovita() {
  const [note, setNote] = useState(null);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { user, apps } = useAuth();
  useEffect(() => { api.get("/novita/archivio").then(({ data }) => setNote(data)).catch(() => setNote([])); }, []);
  const t = q.trim().toLowerCase();
  const visibili = (note || []).filter((n) => !t || [n.versione, n.titolo, ...n.voci].join(" ").toLowerCase().includes(t));

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-6" data-testid="archivio-novita-page">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">Note di rilascio</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-slate-900 flex items-center gap-3">
            <Sparkles className="h-7 w-7 text-brand-orange" /> Archivio novità
          </h1>
        </div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input className="pl-9 bg-white" placeholder="Cerca per versione o parola (es. Sinistri, 2.1.0)" value={q} onChange={(e) => setQ(e.target.value)} data-testid="archivio-search" />
        </div>
        {note === null && <p className="text-sm text-slate-400">Caricamento…</p>}
        {note && visibili.length === 0 && <p className="text-sm text-slate-500" data-testid="archivio-vuoto">Nessuna nota trovata.</p>}
        {visibili.map((n) => <NotaCard key={n.id} n={n} onOpen={navigate} puo={(l) => linkUsabile(user, apps, l)} />)}
      </main>
    </div>
  );
}
